module.exports = __webpack_public_path__ + "static/media/flow1.7555d739.png";